


























































import { Vue, Component, Ref } from 'vue-property-decorator';
import { getValidatePicture, validateImgCode, submitFeedback } from 'service/api';
import { ElForm } from 'element-ui/types/form.d';

@Component
export default class Feedback extends Vue {
  @Ref('form') readonly form!: ElForm;

  userInput = {
    email: '',
    content: '',
    code: '',
  };

  picture = getValidatePicture;

  isValidating = false;

  rules = {
    email: [
      {
        required: true,
        pattern: /^[a-z0-9A-Z]+[-|a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-z]{2,}$/,
        trigger: 'blur',
        message: '请输入正确的邮箱地址',
      },
    ],
    code: [
      { validator: this.validateCode, trigger: 'blur' },
    ],
    content: [
      {
        required: true,
        message: '请输入您遇到的问题',
        trigger: 'blur',
      },
    ],
  };

  submit() {
    this.isValidating = true;
    this.form.validate(async (valid: boolean) => {
      if (valid) {
        try {
          const res = await submitFeedback({ ...this.userInput });
          if ((res as ({ state: boolean; message: string })).state) {
            this.$message.success('提交成功，感谢您的反馈');
          } else {
            this.$notify.error((res as ({ state: boolean; message: string })).message);
          }
        } finally {
          this.isValidating = false;
        }
      }
      this.isValidating = false;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async validateCode(rule: object, value: string, callback: (t?: Error) => void) {
    if (value && value.length === 5) {
      const res = await validateImgCode({ verificationCode: value });
      if ((res as { message: string }).message === '验证成功') {
        callback();
      } else {
        callback(new Error('验证失败,请注意大小写'));
      }
    } else {
      callback(new Error('请输入正确的验证码'));
    }
  }

  refreshImg() {
    this.picture = `${getValidatePicture}${Math.random()}`;
  }
}
